import React from 'react'
import style from './style.css'

export default (props) => (
    <div className={style.formGroup}>
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/atoms/Forms/formGroup.js